export default __webpack_public_path__ + "static/footer_logo_onlineStore-9258ef29-8c7ba151c4493ab7b2e1ea3603f54934.png";